import React from 'react'
import PropTypes from 'prop-types'
import {AspectRatio, Box, Img, useMultiStyleConfig} from '@chakra-ui/react'
import {remCalc} from '../../theme/_utils'
import {useIntl} from 'react-intl'

const EnterKeyNumber = 13
const ProductThumbnail = ({
    image,
    imageRef,
    handleSelection,
    selected = false,
    index,
    loadingStrategy = 'lazy',
    variant = '',
}) => {
    const styles = useMultiStyleConfig('ProductThumbnail', {variant})
    const intl = useIntl()

    const ariaLabel = intl.formatMessage(
        {
            id: 'product_thumbnail.aria_label',
            defaultMessage: 'View image {index}{alt}',
        },
        {
            index: index + 1,
            alt: image?.alt ? `: ${image?.alt}` : '',
        },
    )

    return (
        <AspectRatio
            ref={imageRef}
            ratio={1}
            borderColor={`${selected ? 'border.dark' : 'border.light'}`}
            borderWidth={`${selected ? remCalc(2) : remCalc(1)}`}
            {...styles.thumbnailImageItem}
            boxSizing="content-box"
        >
            <Box
                as="button"
                aria-pressed={selected ? 'true' : 'false'}
                aria-label={ariaLabel}
                onKeyDown={(e) => {
                    if (e.keyCode === EnterKeyNumber) handleSelection()
                }}
                onClick={() => handleSelection(index)}
                data-testid="image-gallery-thumbnails"
            >
                <Img
                    alt={image?.alt}
                    src={image?.disBaseLink || image?.link}
                    loading={loadingStrategy}
                />
            </Box>
        </AspectRatio>
    )
}

ProductThumbnail.propTypes = {
    image: PropTypes.object,
    imageRef: PropTypes.object,
    handleSelection: PropTypes.func,
    index: PropTypes.number,
    loadingStrategy: PropTypes.string,
    selected: PropTypes.bool,
    variant: PropTypes.string,
}

export default ProductThumbnail
